import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {ProjectUtils} from '../project-utils';

@Directive({
    selector: '[appLimitInputLength]',
    standalone: true
})
export class LimitInputLengthDirective {

  @Input() appLimitInputLength:number;

  constructor(private el: ElementRef) {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    if(this.appLimitInputLength){
      const value = this.el.nativeElement.value;
      if(ProjectUtils.checkValueInString(value)){
        if((value.length+1)>this.appLimitInputLength){
          event.preventDefault();
        }
      }
    }else{
      throw new Error('Please pass input length to the directive appLimitInputLength');
    }

  }

}
